import React from "react";
import BlogCard from "./BlogCard";

export default function BlogGrid({ blogs = [] }) {
  if (!blogs.length) {
    return (
      <div className="rounded-2xl border border-dashed border-gray-300 bg-white p-8 text-center text-sm text-gray-500">
        Artikel belum ditemukan.
      </div>
    );
  }

  return (
    <div className="grid gap-6 lg:grid-cols-2">
      {blogs.map((blog) => (
        <BlogCard key={blog.id || blog.slug} blog={blog} />
      ))}
    </div>
  );
}
